<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white p-10 rounded"
    >
      <h3 class="text-lg font-semibold text-blues mb-2">Single Upload Form</h3>
      <form
        @submit.prevent="singleSubmit"
        class="space-y-4"
        ref="addRefs"
      >
        <!-- Name -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label
              for="firstName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >First Name <span class="text-red-400">*</span></label
            >
            <input
              id="firstName"
              type="text"
              placeholder="First Name"
              v-model="firstName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="lastName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Last Name <span class="text-red-400">*</span></label
            >
            <input
              id="lastName"
              type="text"
              placeholder="Last Name"
              v-model="lastName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Email -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email ID <span class="text-red-400">*</span></label
            >
            <input
              id="email"
              type="email"
              placeholder="Email ID"
              v-model="email"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div>
            <label
              for="countryCode"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Mobile Number <span class="text-red-400">*</span></label
            >
            <div class="flex">
              <select
                id="country-form"
                v-model="countryCode"
                @change="setPhoneLength(countryCode)"
                required
                class="w-20 px-3 py-2 border border-gray-300 rounded"
              >
                <option value="" disabled>Select an option</option>
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    countryCode === country.code
                      ? country.code
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                v-model="mobile"
                required
                class="w-full p-2 border border-gray-300 rounded"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                id="Phone_no"
                placeholder="Phone no*"
                :maxlength="max_length"
              />
            </div>
            <span class="text-xs font-normal" v-if="phone_max_length"
              >Please Enter
              <b>{{ phone_max_length }}</b>
              Digit Phone Number</span
            >
          </div>
        </div>

        <!-- Password Option -->
        <div>
          <label class="block font-medium text-gray-700 mb-1"
            >Password <span class="text-red-400">*</span></label
          >
          <div class="flex gap-4 mb-2">
            <label class="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                id="passwordCustom"
                value="custom"
                v-model="passwordOption"
                class="form-radio text-blue-500"
              />
              <span>Custom</span>
            </label>
            <label class="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                id="passwordAuto"
                value="auto"
                v-model="passwordOption"
                class="form-radio text-blue-500"
              />
              <span>Auto Generate</span>
            </label>
          </div>

          <div v-if="passwordOption === 'custom'">
            <label
              for="password"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Custom Password</label
            >
            <input
              id="password"
              type="password"
              placeholder="Enter Password"
              v-model="password"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div v-if="passwordOption === 'auto'">
            <label
              for="password"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Generated Password</label
            >
            <input
              id="password"
              type="text"
              :value="password"
              readonly
              class="w-full p-2 border border-gray-300 rounded bg-gray-100"
            />
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label
              for="applicationNumber"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Application Number <span class="text-red-400">*</span></label
            >
            <input
              id="applicationNumber"
              type="text"
              placeholder="Application Number"
              v-model="applicationNumber"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div>
            <label
              for="selectField"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Program <span class="text-red-400">*</span>
            </label>
            <select
              id="selectField"
              v-model="Program"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" disabled selected>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label
              for="Batch"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Batch <span class="text-red-400">*</span>
            </label>
            <select
              id="Batch"
              v-model="Batch"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" selected disabled>Select Batch</option>
              <option
                v-for="batch in batchs"
                :key="batch.year"
                :value="batch.id"
              >
                {{ batch.year }}
              </option>
            </select>
          </div>
          <div>
            <label
              for="universalRegNumber"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Permanent Registration Number
            </label>
            <input
              id="universalRegNumber"
              type="text"
              placeholder="Enter Permanent Registration Number"
              v-model="universalRegNumber"
              class="w-full p-2 border border-gray-300 rounded"
            />
          </div>
        </div>

        <div>
          <label
            for="department"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Department
          </label>
          <select
            id="department"
            v-model="department"
            class="w-full p-2 border border-gray-300 rounded"
          >
            <option value="" disabled selected>Select Department</option>
            <option
              v-for="department in departments"
              :key="department.id"
              :value="department.id"
            >
              {{ department.name }}
            </option>
          </select>
        </div>
        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
    <div class="mt-10">
      <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
      <div v-if="submittedData.length > 0" class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 border">
          <thead class="bg-blues whitespace-nowrap">
            <tr>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                S.NO
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                First Name
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Last Name
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Email
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Mobile
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Program
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Batch
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Permanent Registration Number
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                ApplicationNumber
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Department
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr v-for="(item, index) in submittedData" :key="index">
              <td class="px-4 py-2 text-sm">{{ (currentPage - 1) * 10 + index + 1 }}</td>
              <td class="px-4 py-2 text-sm">{{ item.first_name }}</td>
              <td class="px-4 py-2 text-sm">{{ item.last_name }}</td>
              <td class="px-4 py-2 text-sm">{{ item.email }}</td>
              <td class="px-4 py-2 text-sm">
                {{ item.phone_number }}
              </td>
              <td class="px-4 py-2 text-sm">{{ item.program }}</td>
              <td class="px-4 py-2 text-sm">{{ item.batch }}</td>
              <td class="px-4 py-2 text-sm">
                {{ item.university_registration_number || "NA" }}
              </td>
              <td class="px-4 py-2 text-sm">
                {{ item.application_number || "NA" }}
              </td>
              <td class="px-4 py-2 text-sm">{{ item.department || "NA" }}</td>
            </tr>
          </tbody>
        </table>

        <div
                class="pb-5 flex items-center justify-center"
              >
                <Pagination :totalPages="totalPages" @page-changed="getsubmit" />
               </div>
      </div>
      <div v-else>No Data Found</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      applicationNumber: "",
      Program: "",
      Batch: "",
      universalRegNumber: "",
      department: "",

      max_length: 10,
      programs: [],
      departments: [],
      batchs: [],
      messages: {
        text: "",
        type: "null",
      },
      submittedData: [],
       totalPages: 0, 
       currentPage: 1,
    };
  },
  components: {
    FlashMessage,
    Pagination
  },
  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: mapGetters(["userInfo"]),
  async created() {
    this.getPrograms();
    this.getDepartments();
    this.batchget();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {
    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },
    async batchget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-filter-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.batchs = res.data.data.data;
          }
        });
    },
    setPhoneLength(phone) {
      const phone_length = this.phoneNumberLengths.filter((item) => {
        return item.phone == phone;
      });
      if (phone_length.length > 0) {
        this.max_length = phone_length[0].phoneLength;
      }
      if (phone == this.selectedCountryCode) {
        this.new_max_length = this.max_length;
      } else {
        this.phone_max_length = this.max_length;
      }
    },
    singleSubmit() {
      const beforeData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        custom_password: this.password,
        auto_generative_password: this.password,
        country_code: this.countryCode,
        phone_number: this.countryCode + " " + this.mobile,
        application_number: this.applicationNumber,
        university_registration_number: this.universalRegNumber,
        user: this.userInfo.user.id,
        // role: this.selected_seat_type,
        program: this.Program,
        batch: this.Batch,
        department: this.department,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/user/signup/?Key=${this.userInfo.token_key}`,
          beforeData
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.getsubmit(1);
              this.$refs.addRefs.reset();

              this.firstName = ""
              this.lastName = ""
              this.email = ""
              this.password = ""
              this.password = ""
              this.countryCode = ""
              this.countryCode = ""
              this.mobile = ""
              this.applicationNumber = ""
              this.universalRegNumber = ""
              this.Program = ""
             this.Batch = ""
              this.department = ""

            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
    getsubmit(number) {
      this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/enrollment-list/?Key=${this.userInfo.token_key}&page=${number}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
              this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
